<template>
  <div class="courseCen" onclick="_hmt.push(['_trackEvent', 'website', 'click', '点击'])">
    <meta
      name="keywords"
      content="财富学堂，私募股权研习社，公开市场研习社，资产保全与增值研习社，资产配置暨巴菲特股东大会，沃顿家族财富传承，以色列创新与文化，欧洲隐形冠军，日本王道经营，意法时尚，北欧童话，南欧艺术启蒙，斯坦福夏令营，青少年商业营，肯尼亚野性之旅，冰岛极地之旅，以诺动力"
    >
    <meta
      name="description"
      content="以诺教育成立于2014年，源起于其母公司诺亚财富（中国财富管理行业的开创者和领军者，2010年率先美国纽交所上市，股票代码NOAH）十多年的学习型组织沉淀，围绕“财富与人生”这个大主题，打造各类拓展视野、跨界创新、凝聚人脉、守护家庭、滋养身心的高端课程，全方位打造高尚、富有、快乐的人生，实现有形财富和无形财富的和谐统一。"
    >
    <title>课程列表-以诺教育</title>
    <headTop></headTop>

    <div class="clears"></div>
    <div class="courseNav">
      <ul class="cnavv">
        <li
          v-for="(item,index) in nav"
          @click="getClasses(item,index)"
          :key="index"
          :class="{zhAct:index==0}"
        >{{item.name}}</li>
      </ul>
    </div>
    <div class="courseCon">
      <!-- <ul class="courseA">
					<li class="activeC">全部</li>
					<li>报名中</li>
					<li>即将开始</li>
      </ul>-->
      <div class="loading" v-show="loading">
        <img src="../../assets/loading.gif">
      </div>
      <!--页面缺省-->
      <div class="zhDefault" v-if="zhDefault">
        <img src="../../assets/default.png" alt>
        <div class="zhDefCon">暂无课程!</div>
      </div>
      <div class="courseList" v-for="(item,index) in list" :key="index">
        <router-link :to="{name:'CourseDetails',params:{id:item.id}}">
          <div class="courseLeft">
            <img :src="item.imgurl" alt="正在加载中。。。">
            <span class="maskText">课程详情</span>
          </div>
        </router-link>
        <div class="courseRight">
          <div class="zhcourR">
            <div class="zhLefts">
              <div class="zhcourRL">{{item.name}}</div>
            </div>
            <div class="zhRights">
              <div class="zhcourRR">开班</div>
              <div class="zhcourRR">{{item.classes_begin}}</div>
              <span class="data"></span>
              <span class="shu">|</span>
              <div class="ming">
                <i class="zhAdd">{{item.address}}</i>
                <span class="di"></span>
              </div>
            </div>
          </div>
          <div class="coursetext">{{item.t_info}}</div>
          <p class="money">
            <b>{{item.price}}</b>
            <span>元/人</span>
          </p>
          <div class="qrcodeBox" v-show="item.qrcode" @mouseleave="hideQrCode(index)">
            <img :src="host + item.qrcode_url" class="qrcode">
            <p class="qrcodeText">微信扫码报名</p>
          </div>
          <div id="courseBtn" @mouseenter="showQrCode(index)">立即报名</div>
          <!-- <div>
            <router-link :to="{name:'CourseDetails',params:{id:item.id}}" id="courseBtn">查看详情</router-link>
          </div> -->
        </div>
      </div>
      <!-- <div class="courseList" v-for="(item,index) in list.filter(item=>item.register_state=='未开始')" @click.stop="navToDetail(item)">
					<div class="courseLeft"><img :src="item.imgurl" alt="正在加载中。。。"/></div>
					<div class="courseRight">
						<div class="zhcourR">
							<div class="zhLefts">
								<div class="zhcourRL">{{item.name}}</div>
							</div>
							<div class="zhRights">
								<div class="zhcourRR">开班</div>
								<div class="zhcourRR">{{item.classes_begin}}</div>
								<span class="data"></span>
								<span class="shu">|</span>
								<div class="ming"><i class="zhAdd">{{item.address}}</i><span class="di"></span></div>
							</div>
						</div>
							<div class="coursetext">{{item.t_info}}</div>
							<p class="money"><b>{{item.price}}</b><span>元/人</span></p>
							<div class="courseBtnT"><router-link :to="{name:'CourseDetails',params:{id:item.id}}"  :disabled="item.register_state=='未开始'?click:click1" >{{time[index]}}天后开始报名</router-link></div>
					</div>
      </div>-->
    </div>
    <div class="Gotop">
      <img src="../../assets/gotop.png">
    </div>
    <Bottom class="zuidi"></Bottom>
  </div>
</template>

<script>
import headTop from "../headTop/headTop";
import Bottom from "../Bottom/Bottom";
import http from "../../http.js";
console.log(http.defaults.baseURL);
export default {
  name: "courseCen",
  components: { headTop, Bottom },
  data() {
    return {
      list: [],
      nav: [],
      name: "",
      click: true,
      click1: false,
      token: localStorage.getItem("token"),
      time: [],
      page: 1,
      status: 0,
      class_id: 0,
      zhDefault: false,
      scroll: "",
      id: "",
      xin: sessionStorage.getItem("xin"),
      host: http.defaults.baseURL
    };
  },
  methods: {
    getClasses(item, index) {
      var that = this;
      that.id = item.id;
      $(".cnavv li").removeClass("zhAct");
      $(".cnavv li")
        .eq(index)
        .addClass("zhAct");
      that.page = 1;
      $(".cnav li").css({ color: "#4f4f4f" });
      $(".cnav li")
        .eq(index)
        .css({ color: "#01b784" });

      for (let i = 0; i < $(".courseA li").length; i++) {
        if (
          $(".courseA li")
            .eq(i)
            .hasClass("activeC")
        ) {
          that.status = i;
        }
      }
      that
        .$ajax({
          method: "post",
          url: "/api/classesGet",
          params: { class_id: item.id, page: that.page, status: that.status }
        })
        .then(function(data) {
          that.list = data.data.result;
          if (that.list.length == 1) {
            $(".zuidi").css({ "margin-top": "6%" });
          } else {
            $(".zuidi").css({ "margin-top": "-235px" });
          }
          if (that.list.length == 0) {
            that.zhDefault = true;
          } else {
            that.zhDefault = false;
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    navToOrder: function(item) {
      if (this.token) {
        this.$router.push({ name: "order", params: { id: item.id } });
      }
    },
    navToDetail(item) {
      this.$router.push({ name: "CourseDetails", params: { id: item.id } });
    },
    showQrCode(idx) {
      console.log(idx);
      // console.log(this)
      this.$set(this.list[idx], "qrcode", true);
      // this.list[idx].qrcode = true;
      console.log("showQrCode");
    },
    hideQrCode(idx) {
      this.$set(this.list[idx], "qrcode", false);
      // this.list[idx].qrcode = false;
      console.log("hideQrCode");
	},
	scrollTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  },
  created() {
    this.loading = true;
    var that = this;
    this.$ajax({
      method: "post",
      url: "/api/classesGet",
      params: { page: that.page }
    })
      .then(function(data) {
        that.loading = false;
        that.list = data.data.result;
        if (that.list.length == 0) {
          that.zhDefault = true;
        } else {
          that.zhDefault = false;
        }
        if (that.list.length > 1) {
          $(".zuidi").css({ "margin-top": "-235px" });
        }
        for (let i = 0; i < that.list.length; i++) {
          if (data.data.result[i].register_state == "未开始") {
            var timer = Math.ceil(data.data.result[i].countdown / 3600 / 24);
            that.time.push(timer);
          }
        }
      })
      .catch(function(err) {
        console.log(err);
        // that.zhDefault = true;
      });
    //滚轮事件
    window.addEventListener("scroll", function() {
      var scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      for (var j = 0; j < $(".cnavv li").length; j++) {
        if (
          $(".cnavv li")
            .eq(j)
            .hasClass("zhAct")
        ) {
          that.class_id = j;
        }
      }
      for (let i = 0; i < $(".courseA li").length; i++) {
        if (
          $(".courseA li")
            .eq(i)
            .hasClass("activeC")
        ) {
          that.status = i;
        }
      }
      /*-----------------------------------刷新------------------------------------*/
      if (document.body.offsetHeight == window.innerHeight) {
        location.reload();
      }
      if (document.body.offsetHeight - window.innerHeight <= scrollTop) {
        that.page += 1;
        that
          .$ajax({
            method: "post",
            url: "/api/classesGet",
            params: {
              page: that.page,
              class_id: that.class_id,
              status: that.status
            }
          })
          .then(function(data) {
            if (data.data.result.length > 0) {
              for (let j = 0; j < data.data.result.length; j++) {
                that.list.push(data.data.result[j]);
              }
              for (let i = 0; i < that.list.length; i++) {
                if (data.data.result[i].register_state == "未开始") {
                  var timer = Math.ceil(
                    data.data.result[i].countdown / 3600 / 24
                  );
                  that.time.push(timer);
                }
              }
            } else {
              return false;
            }
          })
          .catch(function(err) {
            console.log(err);
          });
      }
    });
  },
  mounted() {
	var that = this;
	this.scrollTop()
    $(".courseA li").click(function() {
      $(".courseA li").removeClass("activeC");
      this.className = "activeC";
      var sList = $(this).index();
      that.page = 1;
      for (var j = 0; j < $(".cnavv li").length; j++) {
        if (
          $(".cnavv li")
            .eq(j)
            .hasClass("zhAct")
        ) {
          that.class_id = j;
        }
      }
      that
        .$ajax({
          method: "post",
          url: "/api/classesGet",
          params: { status: sList, page: that.page, class_id: that.id }
        })
        .then(function(data) {
          that.list = data.data.result;
          if (data) {
            that.loading = false;
          }
          if (that.list.length == 1) {
            $(".zuidi").css({ "margin-top": "6%" });
          } else {
            $(".zuidi").css({ "margin-top": "-235px" });
          }
          if (that.list.length == 0) {
            that.zhDefault = true;
          } else {
            that.zhDefault = false;
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    });
    /*--------------------------------初始导航------------------------------*/
    that
      .$ajax({
        method: "post",
        url: "/api/CourseClassGet"
      })
      .then(function(data) {
        that.nav = data.data.result;
      })
      .catch(function(err) {
        console.log(err);
      });

    /*-----------------------------置顶--------------------------------------*/
    $(".Gotop").click(function() {
      $("body,html").animate({ scrollTop: 0 }, 500);
    });
    /*-----------------------------shua--------------------------------------*/
    sessionStorage.setItem("xin", 1);
  }
};
</script>

<style scoped="scoped">
.courseNav {
  width: 100%;
  background: #ffffff;
  margin-bottom: 30px;
}
.cnavv {
  height: 46px;
  width: 1152px;
  margin: 0 auto;
}
.cnavv li {
  float: left;
  line-height: 46px;
  margin-right: 30px;
  cursor: pointer;
}
.courseCen {
  background: #f4f5f9;
  min-height: 100%;
  width: 100%;
  padding-bottom: 1px;
}
.courseCon {
  width: 1160px;
  margin: 0 auto;
  padding-bottom: 235px;
  min-height: 890px;
}
.courseA {
  margin: 25px 0 20px 0;
  height: 28px;
  display: inline-block;
  vertical-align: bottom;
}
.courseA li {
  float: left;
  line-height: 28px;
  width: 60px;
  text-align: center;
  margin-left: 14px;
  height: 28px;
  cursor: pointer;
}
.activeC {
  background: #11cc99;
  color: #fff;
  border-radius: 20px;
}
.activeN {
  color: #01b784;
}
.courseList {
  clear: both;
  height: 249px;
  width: 1160px;
  margin-bottom: 30px;
}
.courseList:hover {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

.courseLeft {
  width: 500px;
  height: 249px;
  float: left;
  position: relative;
}
.courseLeft::before {
  content: "";
  width: 0;
  height: 249px;
  background: #000;
  position: absolute;
  top: 0;
  left: 50%;
  opacity: 0;
  transition: all 500ms cubic-bezier(0.47, 0, 0.745, 0.715) 0s;
}
.courseLeft:hover::before {
  left: 0;
  width: 100%;
  opacity: 0.5;
}
.courseLeft img {
  width: 500px;
  height: 249px;
}
.maskText {
  width: 500px;
  height: 249px;
  text-align: center;
  line-height: 249px;
  color: #fff;
  font-size: 24px;
  position: absolute;
  top: 0;
  opacity: 0;
  transition: all 0.5s ease 0s;
}
.courseLeft:hover .maskText {
  opacity: 1;
  transition-delay: 0.7s;
}

/* .courseLeft{width:500px;height:249px;float:left;position:relative;}
	.courseLeft:hover::before {content:'';width:0;height:249px;background:#000;position: absolute;top: 0;left: 50%;opacity: 0;transition: all 500ms cubic-bezier(0.47, 0, 0.745, 0.715) 0s;}
	.courseLeft::before {left:0;width:100%;opacity: 0.5;}
	.courseLeft img{width:500px;height:249px;}
	.courseLeft:hover .maskText{width:500px;height:249px;text-align:center;line-height:249px;color:#fff;font-size:24px;position:absolute;top:0;opacity: 0;transition: all 0.5s ease 0s;}
	.maskText{opacity: 1;transition-delay: 0.7s;} */

.courseRight {
  width: 660px;
  height: 249px;
  float: left;
  background: #fff;
  position: relative;
}
.courseH1 {
  font-size: 20px;
  margin: 30px 0 15px 30px;
  float: left;
}
.courseDate {
  float: right;
  margin: 30px 30px 15px 0;
}
.di {
  width: 20px;
  height: 20px;
  background: url(../../assets/pcq.png) no-repeat -20px -20px;
  float: right;
  margin-right: 8px;
}
.zhAdd {
  float: right;
  font-style: normal;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100px;
}
.data {
  width: 20px;
  height: 20px;
  background: url(../../assets/pcq.png) no-repeat -20px -60px;
  float: right;
  margin-right: 8px;
}
.ming {
  float: right;
  width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 25px;
}
.shu {
  height: 20px;
  float: right;
  width: 1px;
  display: block;
  padding: 0 14px 0 14px;
  color: #e0e0e0;
}
.coursetext {
  width: 600px;
  clear: both;
  margin-left: 30px;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  color: #909090;
}
.money {
  color: #01b784;
  position: absolute;
  bottom: 27px;
  left: 30px;
}
.money b {
  font-size: 20px;
  font-weight: 100;
}
.money span {
  font-size: 12px;
}
#courseBtn {
  width: 160px;
  line-height: 40px;
  border: 0;
  position: absolute;
  right: 30px;
  bottom: 20px;
  color: #fff;
  background: #11cc99;
  border-radius: 5px;
  text-align: center;
}
/* #courseBtn{width:160px;line-height:40px;border:0;position:absolute;right:30px;bottom:20px;color:#fff;background:#11cc99;border-radius: 5px;text-align: center;} */
#courseBtn a {
  color: #fff;
}
.courseBtnT a {
  color: #909090;
}
.courseBtnT {
  width: 160px;
  line-height: 40px;
  border: 0;
  position: absolute;
  right: 30px;
  bottom: 20px;
  color: #909090;
  background: #dddddd;
  border-radius: 5px;
  text-align: center;
}
.clears {
  clear: both;
}
.courseList a:visited {
  color: #333;
}
.courseList a {
  color: #333;
}
.cnavv .zhAct {
  color: #01b784;
}
/*修改*/
.zhcourR {
  width: 100%;
  height: 70px;
  box-sizing: border-box;
  padding: 30px 30px 15px 30px;
  box-sizing: border-box;
  overflow: hidden;
  color: #4f4f4f;
  font-size: 14px;
  display: flex;
  display: -ms-flexbox;
  align-items: center;
  justify-content: space-between;
}
.zhLefts {
  width: 50%;
  height: 25px;
  float: left;
}
.zhRights {
  width: 50%;
  height: 25px;
  float: right;
}
.zhcourR .zhcourRL {
  font-size: 20px;
  font-weight: 600;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 100%;
  line-height: 25px;
}
.zhcourRR {
  float: right;
  height: 100%;
  line-height: 25px;
}
.zhDefault {
  width: 100%;
  padding: 30px 0;
}
.zhDefault > img {
  display: block;
  margin: 0 auto;
}
.zhDefCon {
  font-size: 24px;
  color: #4f4f4f;
  text-align: center;
  padding-top: 30px;
}
.Gotop {
  position: fixed;
  right: 30px;
  bottom: 50px;
  z-index: 20;
}
.loading {
  width: 100%;
  min-height: 720px;
  display: flex;
  display: -ms-flexbox;
  justify-content: center;
  align-items: center;
  background: #fff;
}

.qrcodeBox {
  width: 160px;
  height: 160px;
  position: absolute;
  right: 30px;
  bottom: 20px;
  background-color: #fff;
  z-index: 100;
}
.qrcode {
  width: 124px;
  height: 124px;
  margin: 0 auto 10px;
}
.qrcodeText {
  width: 100%;
  height: 20px;
  line-height: 20px;
  font-size: 16px;
  color: #11cc99;
  font-weight: bold;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// courseCen.vue?707ce289